import React from "react";

const ConferencesDelegations = () => {
  return (
    <>
      {/* ===== BREADCRUMB ===== */}

<section
        className="breadcrumb-section"
        style={{
          backgroundImage:
            "url(/images/background/inner-banner-bg.jpg)",
        }}
      >
        <div className="container">
          <div className="banner-content text-center">
            <h1>Conferences & Delegations</h1>
          </div>
        </div>
      </section>



      {/* ===== MAIN CONTENT SECTION ===== */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center">

            {/* IMAGE */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img
                src="images/gallery/02.jpeg"
                alt="Conference and Delegation Transport Services"
                className="img-fluid rounded shadow-lg"
              />
            </div>

            {/* CONTENT */}
            <div className="col-lg-6">
              <h2 className="mb-3">
                <span className="text-danger">Conference</span> & Delegation
                Transportation Services
              </h2>

              <p>
                Pune Corporate Cars India Pvt. Ltd. offers end-to-end
                transportation solutions for conferences, exhibitions,
                seminars, corporate events, and high-profile delegations.
                We manage complex mobility requirements with precision,
                confidentiality, and professionalism.
              </p>

              <p>
                Our experienced operations team plans and executes
                transportation for delegates, speakers, VIP guests,
                and international visitors, ensuring smooth airport
                transfers, venue movements, and hotel coordination.
              </p>

              <p>
                With a well-maintained premium fleet and protocol-trained
                chauffeurs, we ensure punctuality, comfort, and
                adherence to corporate and government protocols throughout
                the event duration.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* ===== WHY CHOOSE US ===== */}
      <section className="py-5 bg-light">
        <div className="container">

          <div className="row mb-4">
            <div className="col-12 text-center">
              <h2 className="mb-3">Why Choose Us for Conferences & Delegations?</h2>
              <p className="text-muted">
                Trusted mobility partner for large-scale corporate and
                government events across Pune and India.
              </p>
            </div>
          </div>

          <div className="row">

            <div className="col-md-6 mb-4">
              <ul className="list-unstyled">
                <li className="mb-3">✔ End-to-end event transportation planning</li>
                <li className="mb-3">✔ Dedicated event & fleet managers</li>
                <li className="mb-3">✔ Protocol-trained and uniformed chauffeurs</li>
                <li className="mb-3">✔ Airport pickup & drop for delegates</li>
              </ul>
            </div>

            <div className="col-md-6 mb-4">
              <ul className="list-unstyled">
                <li className="mb-3">✔ Premium sedans, SUVs & luxury vehicles</li>
                <li className="mb-3">✔ Real-time coordination & control room support</li>
                <li className="mb-3">✔ 24×7 operations during events</li>
                <li className="mb-3">✔ Safety, compliance & confidentiality assured</li>
              </ul>
            </div>

          </div>

        </div>
      </section>
    </>
  );
};

export default ConferencesDelegations;
